module.exports = __webpack_public_path__ + "static/media/Salesloft-Logo.63ae9632.jpeg";